import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'


export const SC_InstallPrompt = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  background: ${E_Colors.White};
  border: 1px solid ${E_Colors.Gray88};
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  align-items: center;
  gap: 12px;
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    left: auto;
    right: 20px;
    bottom: 20px;
  }
`

export const SC_InstallContent = styled.div`
  flex: 1;
`

export const SC_InstallTitle = styled.div`
  font-weight: 600;
  color: ${E_Colors.TextPrimary};
  margin-bottom: 4px;
`

export const SC_InstallDescription = styled.div`
  font-size: 14px;
  color: ${E_Colors.Gray66};
  line-height: 1.4;
`

export const SC_InstallActions = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`

export const SC_InstallButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;

  ${(p) => p.$variant === 'primary' ? `
    background: ${E_Colors.MainColorAccent};
    color: ${E_Colors.White};

    &:hover {
      background: ${E_Colors.EraBlue};
    }
  ` : `
    background: transparent;
    color: ${E_Colors.Gray66};

    &:hover {
      background: ${E_Colors.Gray88};
    }
  `}
`

export const SC_CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  color: ${E_Colors.Gray66};
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background: ${E_Colors.Gray88};
  }
`
